export const whyThisProgramTemplate = {
  id: 'whyThisProgram',
  title: 'Why This Program?',
  description: 'For prompts asking why you want to attend this specific program, what drew you to it, or why it\'s the right fit',
  wordTarget: 250,
  sections: [
    {
      id: 'the_hook',
      label: 'The Hook',
      type: 'opening',
      prompt: 'What specifically about this program caught your attention? Not the reputation — the actual thing that made you stop scrolling.',
      coachVoice: "Don't lead with rankings or prestige. Admissions readers can spot that from a mile away. What specific detail — a research project, a unique curriculum element, a particular faculty member's work — genuinely excited you?",
      sample: "When I found Dr. Patel's lab page showing how her team uses machine learning to predict antibiotic resistance patterns, I realized this wasn't just another summer research program — it was exactly the intersection of AI and medicine I'd been trying to find on my own.",
      minWords: 50,
      unlockWords: 25
    },
    {
      id: 'your_specific_fit',
      label: 'Your Specific Fit',
      type: 'connection',
      prompt: 'How does your background, experience, or current work connect to what this program offers?',
      coachVoice: "Draw a direct line between something you've already done and something this program specifically offers. Generic interest isn't enough — show them you've done your homework.",
      sample: "My independent project classifying local plant diseases using image recognition gave me enough coding experience to know what I don't know yet. The program's computational biology module would fill exactly that gap — moving from hobby-level Python scripts to rigorous research methodology.",
      minWords: 60,
      unlockWords: 30
    },
    {
      id: 'what_youll_bring',
      label: 'What You\'ll Bring',
      type: 'contribution',
      prompt: 'What perspective, skill, or energy will you contribute to the program community?',
      coachVoice: "Programs aren't just selecting students — they're building a cohort. What makes you a good collaborator, not just a good applicant?",
      sample: "Growing up translating medical instructions for my Spanish-speaking grandmother taught me that technical knowledge means nothing if you can't communicate it across barriers. In group research settings, I naturally become the person who bridges disciplines — translating between the coders and the biologists.",
      minWords: 50,
      unlockWords: 25
    },
    {
      id: 'your_vision',
      label: 'Your Vision',
      type: 'growth',
      prompt: 'What do you hope to be able to do, understand, or pursue after this experience that you can\'t right now?',
      coachVoice: "Be specific about growth, not generic about 'learning a lot.' What concrete capability or understanding are you missing that this program would help you develop?",
      sample: "Right now I can build a model and I can read a research paper, but I can't design an experiment that produces publishable data. I want to leave this program knowing how to formulate a testable hypothesis and execute the full research cycle — from question to conclusion.",
      minWords: 50,
      unlockWords: 25
    }
  ]
};
